import { render, staticRenderFns } from "./RemovePassengerFromGroupConfirmationDialog.vue?vue&type=template&id=035b1c6c"
import script from "./RemovePassengerFromGroupConfirmationDialog.vue?vue&type=script&lang=ts"
export * from "./RemovePassengerFromGroupConfirmationDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports